module.exports = __webpack_public_path__ + "media/images/23img-5e0898b80cbeceae533aba80c75d2ac5.jpg";